import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";
import { useState, useEffect } from "react";

const countries = [
    { code: "us", name: "English" },
    { code: "de", name: "Deutsch" },
    { code: "ba", name: "Bosanski" },
];

const LanguageSelector = ({ onLanguageChange }) => {
    const { i18n, t } = useTranslation();
    const [language, setLanguage] = useState(i18n.language);

    useEffect(() => {
        setLanguage(i18n.language);
    }, [i18n.language]);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng.toLowerCase());
        setLanguage(lng);
        if (onLanguageChange) onLanguageChange(false);
    };

    const activeCountry = countries.find(c => c.code === language);

    return (
        <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
                <ReactCountryFlag
                    countryCode={activeCountry?.code}
                    svg
                    style={{ marginRight: "8px", width: "1.5em", height: "1.5em" }}
                />
                {t(language)}
            </DropdownToggle>
            <DropdownMenu end>
                {countries.map((country) => (
                    <DropdownItem
                        key={country.code}
                        onClick={() => changeLanguage(country.code)}
                        active={language === country.code}
                    >
                        <ReactCountryFlag
                            countryCode={country.code}
                            svg
                            style={{ marginRight: "10px", width: "1.5em", height: "1.5em" }}
                        />
                        {t(country.code)}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

export default LanguageSelector;